import React, {useEffect, useRef, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import Dialog from "@mui/material/Dialog";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function LanguageLocaleCreate({locale, onClose, onSubmit}) {
    const [name, setName] = useState(locale ? locale.name : '');
    const [code, setCode] = useState(locale ? locale.code : '');
    const [regionCode, setRegionCode] = useState(locale ? locale.regionCode : '');
    const [languageId, setLanguageId] = useState(locale ? locale.languageId : '');
    const [languages, setLanguages] = useState([]);

    const dialogRef = useRef(null);

    useEffect(() => {
        const fetchLanguages = async () => {
            try {
                const response = await apiClient.get('/languages');
                setLanguages(response.data.list);
            } catch (error) {
                console.error('Error fetching languages:', error);
            }
        };

        fetchLanguages();
    }, []);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({name, code, regionCode, languageId});
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{locale ? 'Edit' : 'Create'} Language Locale</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    name="name"
                                    variant="standard"
                                    value={name}
                                    fullWidth
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="code"
                                    label="Code"
                                    name="code"
                                    variant="standard"
                                    value={code}
                                    fullWidth
                                    onChange={e => setCode(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="regionCode"
                                    label="Region Code"
                                    name="regionCode"
                                    variant="standard"
                                    value={regionCode}
                                    fullWidth
                                    onChange={e => setRegionCode(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="languageLabel">Select a Language</InputLabel>
                                    <Select
                                        labelId="languageLabel"
                                        id="language"
                                        value={languageId}
                                        label="Language"
                                        onChange={e => setLanguageId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {languages.map(language => (
                                            <MenuItem value={language.id}>{language.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default LanguageLocaleCreate;
